import axios from 'axios';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import styles from './Reply.module.scss';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

const Reply = (props) => {

  const [openMenu, setOpenMenu]  = useState(false);

  const location = useLocation();
  const params = qs.parse(location.search);

  const deleteReply = ()=>{
    const _params = { ...params };
    _params.rootId = props.info.rootId;
    _params.parentId = props.info.parentId;
    _params.id = props.info.id;

    axios.get('/api/reply/delete?' + qs.stringify(_params))
    .then((res) => {

    })
    .catch((err)=>{ 
      
    })
    .finally(()=>{
      props.reFetch();
    });
  }
  
  return (
    <div className={styles.wrapper_reply} style={props.isMine ? {backgroundColor:'rgba(235, 235, 235, 1)'} : {}}>
      <div className={styles.body} style={{ width: props.info.isChild ? '93%' : '99%' }}>
        {(props.info.isDeleted === 'Y') ?
        <div className={styles.deleted}>
          <p>삭제된 댓글입니다.</p>
        </div>
          :
          <>
            <div className={styles.writer_info}>
              <div className={styles.img_profile} />
              <p className={styles.writer_nickname}>{props.info.writerNickname}</p>
            </div>
            {props.isMine && 
            <div className={styles.menu} onMouseLeave={()=>{setOpenMenu(false)}}>
              <p className={styles.menu_button} onClick={()=>{setOpenMenu(!openMenu)}}>...</p>
              {openMenu &&
          <div className={styles.menu_nav}>
            <p onClick={()=>{props.editReply()}}>수정</p> 
            <p onClick={deleteReply}>삭제</p> 
          </div>
              }
          </div>
            }

            <div className={styles.content}>
              {props.info.content}
            </div>
            <div className={styles.footer}>
              <p>{props.info.writeDate}</p>
              <p className={styles.write_comment} onClick={()=>{props.reReply()}}>댓글 쓰기</p>
            </div>
          </>
        }
      </div>

    </div>
  )
}

export default Reply;